import { SnackbarKey, SnackbarMessage, OptionsObject } from 'notistack';
import { Action } from 'redux';

import { INotification } from './reducer';

// --------------
// Actions
// --------------
export enum SNACKBAR_ACTIONS {
  ENQUEUE = 'SNACKBAR_ACTIONS/ENQUEUE',
  CLOSE = 'SNACKBAR_ACTIONS/CLOSE',
  REMOVE = 'SNACKBAR_ACTIONS/REMOVE',
}

// --------------
// Action types
// --------------

export interface IEnqueueSnackbar extends Action<SNACKBAR_ACTIONS.ENQUEUE> {
  notification: INotification;
}
export interface ICloseSnackbar extends Action<SNACKBAR_ACTIONS.CLOSE> {
  dismissAll: boolean;
  key: SnackbarKey;
}
export interface IRemoveSnackbar extends Action<SNACKBAR_ACTIONS.REMOVE> {
  key: SnackbarKey;
}

export type ISnackbarActions =
  | IEnqueueSnackbar
  | ICloseSnackbar
  | IRemoveSnackbar;

// --------------
// Action creators
// --------------

export interface IPayload {
  message: SnackbarMessage;
  options?: OptionsObject;
}

export const enqueueSnackbar = (payload: IPayload): IEnqueueSnackbar => {
  const key = payload.options && payload.options.key;

  return {
    type: SNACKBAR_ACTIONS.ENQUEUE,
    notification: {
      ...payload,
      key: key || new Date().getTime() + Math.random(),
      dismissed: false,
    },
  };
};

export const closeSnackbar = (key: SnackbarKey): ICloseSnackbar => ({
  type: SNACKBAR_ACTIONS.CLOSE,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeSnackbar = (key: SnackbarKey): IRemoveSnackbar => ({
  type: SNACKBAR_ACTIONS.REMOVE,
  key,
});
